// @flow

import type {UserIdState} from '@travel-frontend/user-id';
import type {ApplicationRedux} from 'redux/ApplicationRedux';
import type {AccessibilityState} from 'redux/uiState/accessibility/accessibilityState';
import type {AvailabilityState} from 'redux/uiState/availability/AvailabilityState';
import type {InsuranceState} from 'redux/uiState/insurance/InsuranceState';
import type {LayoutState} from 'redux/uiState/layout/LayoutState';
import type {LeadsState} from 'redux/uiState/lead/LeadsState';
import type {PaymentState} from 'redux/uiState/payment/PaymentState';
import type {PriceoverviewState} from 'redux/uiState/priceoverview/PriceoverviewState';
import type {ProfileState} from 'redux/uiState/profile/ProfileState';
import type {TrackingState} from 'redux/uiState/tracking/TrackingState';

import {uiState} from 'redux/ApplicationRedux';

export type UiState = {
  layout: LayoutState,
  priceoverview: PriceoverviewState,
  userId: UserIdState,
  payment: PaymentState,
  tracking: TrackingState,
  insurance: InsuranceState,
  availability: AvailabilityState,
  profile: ProfileState,
  accessibility: AccessibilityState,
  leads: LeadsState,
};

export const layoutState = (state: ApplicationRedux): LayoutState =>
  uiState(state).layout;

export const priceoverviewState = (
  state: ApplicationRedux
): PriceoverviewState => uiState(state).priceoverview;

export const userIdState = (state: ApplicationRedux): UserIdState =>
  uiState(state).userId;

export const paymentState = (state: ApplicationRedux): PaymentState =>
  uiState(state).payment;

export const trackingState = (state: ApplicationRedux): TrackingState =>
  uiState(state).tracking;

export const insuranceState = (state: ApplicationRedux): InsuranceState =>
  uiState(state).insurance;

export const availabilityState = (state: ApplicationRedux): AvailabilityState =>
  uiState(state).availability;

export const profileState = (state: ApplicationRedux): ProfileState =>
  uiState(state).profile;

export const accessibilityState = (
  state: ApplicationRedux
): AccessibilityState => uiState(state).accessibility;

export const leadsState = (state: ApplicationRedux): LeadsState =>
  uiState(state).leads;
